import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const items = el.querySelectorAll('.hero-animate');
    items.forEach((item, i) => {
      (item as HTMLElement).style.animationDelay = `${i * 0.15}s`;
      item.classList.add('animate-fade-up');
    });
  }, []);

  return (
    <section ref={ref} className="min-h-screen flex flex-col lg:flex-row">
      {/* Left panel */}
      <div className="flex-1 bg-[#FAFAF8] flex flex-col justify-end pb-16 md:pb-24 pt-28 md:pt-32 px-8 md:px-14 lg:px-16">
        <span className="hero-animate opacity-0-init text-xs font-medium tracking-[0.3em] text-stone-400 uppercase mb-8 md:mb-12">
          Bordeaux &middot; Design
        </span>
        <h1 className="hero-animate opacity-0-init leading-none">
          <span className="block font-serif-display font-bold text-[clamp(64px,10vw,120px)] text-stone-900 tracking-tight">
            Studio
          </span>
          <span className="block font-serif-display font-light italic text-[clamp(40px,6vw,64px)] text-stone-500 ml-4 md:ml-8 -mt-1">
            de
          </span>
          <span className="block font-serif-display font-bold text-[clamp(64px,10vw,120px)] text-stone-900 tracking-tight -mt-2">
            design
          </span>
        </h1>
      </div>

      {/* Right panel */}
      <div className="flex-1 bg-[#F4F1EC] flex flex-col justify-center px-8 md:px-14 lg:px-16 py-16 md:py-24">
        <div className="max-w-md">
          <p className="hero-animate opacity-0-init text-base md:text-lg text-stone-600 leading-[1.85] mb-10">
            <strong className="font-semibold text-stone-900">KURTA</strong> propose des services de design graphique pour les entreprises et les particuliers à Bordeaux. L&apos;objectif est de créer des visuels simples, modernes et efficaces.
          </p>
          <div className="hero-animate opacity-0-init flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-stone-900 text-white text-sm font-medium rounded-full hover:bg-stone-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Prendre contact
              <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center" />
            </Link>
            <Link
              to="/a-propos"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-stone-300 text-stone-700 text-sm font-medium rounded-full hover:border-stone-900 hover:text-stone-900 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              À propos
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}